<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn
					v-if="authority_flag"
					color="white"
					text
					class="ml-2"
					@click="$router.push({ name: 'delivery_order_new' })"
				>
					<v-icon class="mr-1">mdi-plus</v-icon>
					配車依頼書作成
				</v-btn>
				<DeliveryOrderSearchDialog
					:query="q"
					:suppliers="suppliers"
					@search-delivery-orders="searchDeliveryOrders($event)"
					text
				/>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<v-btn
						v-if="authority_flag"
						color="secondary"
						class="ml-2"
						@click="$router.push({ name: 'delivery_order_new' })"
					>
						<v-icon class="mr-1">mdi-plus</v-icon>
						配車依頼書作成
					</v-btn>
					<DeliveryOrderSearchDialog
						:query="q"
						:suppliers="suppliers"
						@search-delivery-orders="searchDeliveryOrders($event)"
					/>
				</v-row>
			</template>

			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="delivery_orders"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="showDialog(item.id)">
							<td>{{ item.status_type_i18n }}</td>
							<td>
								{{ formattedOrderNumber(item) }}
							</td>
							<td>{{ common.formatDate(item.order_date) }}</td>
							<td>{{ item.supplier.name }}</td>
							<td>{{ item.shipping_place.name }}</td>
							<td class="text-right">{{ Number(item.price).toLocaleString() + "円" }}</td>
							<td>{{ item.user.full_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<DeliveryOrderShowDialog
			:dialog.sync="dialog"
			:id="selectedId"
			@reload-delivery-orders="fetchDeliveryOrders(q, pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import DeliveryOrderSearchDialog from "./components/DeliveryOrderSearchDialog.vue"
import DeliveryOrderShowDialog from "./components/DeliveryOrderShowDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		DeliveryOrderSearchDialog,
		DeliveryOrderShowDialog,
	},
	data() {
		return {
			title: "配車依頼書一覧",
			delivery_orders: [],
			authority_flag: false,
			headers: [
				{
					text: "状況",
					value: "status_type_i18n",
					width: "100px",
				},
				{
					text: "注文番号",
					value: "order_number",
					width: "150px",
				},
				{
					text: "発注日",
					value: "order_date",
					width: "100px",
				},
				{
					text: "運送会社",
					value: "supplier.name",
					width: "200px",
				},
				{
					text: "集荷場所",
					value: "shipping_place.name",
					width: "100px",
				},
				{
					text: "金額",
					value: "price",
					width: "150px",
				},
				{
					text: "発注者",
					value: "user.full_name",
					width: "120px",
				},
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "updated_at desc",
				supplier_id_eq: null,
				order_date_lteq: null,
				order_date_gteq: null,
				status_type_in: ["sent", "draft", "pending", "rejected"],
			},
			suppliers: [],
			selectedId: null,
			dialog: null,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		if (this.$route.query.open) {
			const id = this.$route.query.id
			this.showDialog(id)
		}
		this.setQuery()
		this.fetchDeliveryOrders(this.q, page, true)
		if (this.$router.query?.id) this.showDialog(this.$router.query.id)
	},
	methods: {
		fetchDeliveryOrders(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/delivery_orders", {
					params,
					headers,
				})
				.then((response) => {
					this.delivery_orders = response.data.delivery_orders
					this.pagination = response.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.suppliers = response.data.suppliers
						this.authority_flag = response.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		formattedOrderNumber(delivery_order) {
			if (delivery_order.sub_number) {
				return `${delivery_order.order_number}-${String(delivery_order.sub_number).padStart(3, "0")}`
			} else {
				return delivery_order.order_number
			}
		},
		showDialog(id) {
			this.selectedId = id
			this.dialog = true
		},
		getPage(page) {
			this.fetchDeliveryOrders(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchDeliveryOrders(q) {
			this.q = q
			this.fetchDeliveryOrders(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}
</script>
